<template>
  <v-main class="preview-layout">
    <editor-mode-toggle></editor-mode-toggle>

    <v-container fluid class="pa-0">
      <v-row no-gutters>
        <v-col>
          <v-card tile flat>
            <v-card-text class="pa-0">
              <slot></slot>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import '@/assets/scss/webble.frontend.scss'
import '@/assets/scss/webble.mobile.scss'
import EditorModeToggle from '@/components/editor/EditorModeToggle'

export default {
  name: 'PreviewLayout',
  components: {
    EditorModeToggle
  }
}
</script>
